var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "dd",
    { staticClass: "agreement" },
    [
      _vm.invalid
        ? [
            _c("span", { staticClass: "errNote pb-10" }, [
              _vm._v("ＪリーグID利用規約への同意が必要です。"),
            ]),
          ]
        : _vm._e(),
      _vm._v(" "),
      _c(
        "label",
        {
          staticClass: "chk",
          attrs: { tabindex: 0 },
          on: {
            keydown: function ($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
              )
                return null
              return _vm.executeChangeOnEnter.apply(null, arguments)
            },
          },
        },
        [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.agreement,
                expression: "agreement",
              },
            ],
            staticClass: "require-agreement",
            attrs: { type: "checkbox", value: "agree", tabindex: "-1" },
            domProps: {
              checked: Array.isArray(_vm.agreement)
                ? _vm._i(_vm.agreement, "agree") > -1
                : _vm.agreement,
            },
            on: {
              change: [
                function ($event) {
                  var $$a = _vm.agreement,
                    $$el = $event.target,
                    $$c = $$el.checked ? true : false
                  if (Array.isArray($$a)) {
                    var $$v = "agree",
                      $$i = _vm._i($$a, $$v)
                    if ($$el.checked) {
                      $$i < 0 && (_vm.agreement = $$a.concat([$$v]))
                    } else {
                      $$i > -1 &&
                        (_vm.agreement = $$a
                          .slice(0, $$i)
                          .concat($$a.slice($$i + 1)))
                    }
                  } else {
                    _vm.agreement = $$c
                  }
                },
                _vm.change,
              ],
            },
          }),
          _vm._v(" "),
          _c("i"),
          _vm._v("ＪリーグID利用規約に同意します。\n    "),
        ]
      ),
      _vm._v(" "),
      _vm._m(0),
    ],
    2
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "formNote" }, [
      _c(
        "a",
        {
          attrs: {
            target: "_blank",
            href: "https://auth2.jleague.jp/contents/agreement.html",
          },
        },
        [_vm._v("ＪリーグID利用規約を確認する")]
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }